import "../ComponentsStyling/About.css";
import { useGlobalReveal } from "../utils/useGlobalReveal";
import { IconGitHub } from "./ChannelIcons";

/**
 * About — bio section with profile photo, availability badge, and CTAs.
 *
 * Content fades in via a scroll-reveal hook; per-element entrance timing is
 * staggered through the `--d` CSS custom property.
 */
export default function About() {
  const [ref, inView] = useGlobalReveal({ threshold: 0.13 });
  return (
    <section className="abt" id="about" ref={ref}>
      <div className="abt__dots" aria-hidden="true" />
      <div className="abt__blob--a" aria-hidden="true" />
      <div className="abt__blob--b" aria-hidden="true" />

      <div className={`abt__inner${inView ? " abt__inner--in" : ""}`}>

        {/* Section header */}
        <div className="abt__head">
          <div className="abt__eyebrow">
            <span className="abt__ey-n">02</span>
            <span className="abt__ey-l" aria-hidden="true" />
            <span className="abt__ey-t">About Me</span>
          </div>

          <h2 className="abt__h2">
            <span style={{ "--d": "0s" }}>Frontend developer</span>
            <span style={{ "--d": ".07s" }}>
              who ships <em className="abt__em">real work.</em>
            </span>
          </h2>
        </div>

        <div className={`abt__sep${inView ? " abt__sep--in" : ""}`} aria-hidden="true" />

        {/* Body: photo + text content */}
        <div className="abt__body">

          {/* Profile photo with availability badge */}
          <div className="abt__photo-wrap" style={{ "--d": ".1s" }}>
            <img
              src="/images/About/khaled.jpeg"
              alt="Khaled Raed — Frontend Developer"
              className="abt__photo"
              loading="lazy"
              decoding="async"
            />
            <span className="avail avail--on-photo abt__avail">
              Available for freelance
            </span>
          </div>

          {/* Text content: name, bio, and CTAs */}
          <div className="abt__content">

            <div className="abt__name-block" style={{ "--d": ".12s" }}>
              <span className="abt__name">Khaled Raed</span>
              <span className="abt__role">Frontend Developer · Amman, Jordan</span>
            </div>

            <p className="abt__bio" style={{ "--d": ".18s" }}>
              A Computer Science student at the University of Jordan, currently a <strong>Software Engineer Intern at Shabakkat KSA</strong>, and a Frontend Developer focused on fast, accessible, responsive interfaces.
            </p>

            <p className="abt__bio" style={{ "--d": ".23s" }}>
              Over the past two years I've shipped real, deployed websites for organizations and events — including <strong>IEEE CIS UJ</strong>, <strong>TEDx University of Jordan</strong>, and <strong>AI Expo</strong> — owning design, build, and deployment end to end.
            </p>

            <p className="abt__bio" style={{ "--d": ".26s" }}>
              I work primarily with React, JavaScript, and modern CSS, and I care about clean code, performance, and the small details. Alongside my internship I'm <strong>available for freelance work.</strong>
            </p>

            {/* CTAs: view work, download CV, GitHub */}
            <div className="abt__ctas" style={{ "--d": ".3s" }}>
              <a href="#work" className="btn btn--primary">
                View My Work
                <svg className="btn__icon btn__icon--arrow" viewBox="0 0 16 16"
                  fill="none" aria-hidden="true">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor"
                    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>

              <a href="/CV.pdf" download target="_blank" rel="noopener noreferrer"
                className="btn btn--secondary">
                <svg className="btn__icon btn__icon--down" viewBox="0 0 18 18"
                  fill="none" aria-hidden="true">
                  <path d="M9 3v8M6 8l3 3 3-3M4 14h10" stroke="currentColor"
                    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Download CV
              </a>

              <a href="https://github.com/KhaledRaed" target="_blank"
                rel="noopener noreferrer"
                className="btn btn--ghost">
                {/* This section carried a FOURTH hand-pasted copy of the GitHub
                    mark, with its own path data again. It comes from the shared
                    ChannelIcons module like every other one now. */}
                <IconGitHub className="btn__icon" />
                GitHub
              </a>

            </div>

          </div>
        </div>

      </div>
    </section>
  );
}